<template>
  <nav class="c-pagination" v-if="items.total_pages > 1">
  	<ul class="c-pagination__list h-list">
  		<li class="c-pagination__item" v-bind:class="{ 'is-active': isActive(n) }" v-for="n in items.total_pages">
  			<a href="#" v-on:click.prevent="paginate(n)" class="c-pagination__link">{{n}}</a>
  		</li>
  	</ul>
  </nav>
</template>

<script>
  export default {
		name: 'v-pagination',
    data () {
      return {
        activeItem: 1
      }
    },
    props: {
      items: {
        type: Object
      },
      eventName: {
        type: String
      }
    },
    mounted() {
      this.activeItem = this.items.current_page
    },
    methods: {
      paginate(n) {
        this.activeItem = n;
        this.$emit('paginate', n);
      },
      isActive(n) {
        return this.activeItem === n;
      }
    },
	}
</script>



// WEBPACK FOOTER //
// pagination.vue?27564b31